"use client"

import { Email } from "./types"
import BackButton from "./BackButton"

type EmailViewProps = {
	email: Email
	onBack: () => void
}

export default function EmailView({ email, onBack }: EmailViewProps) {
	return (
		<div
			className="
				flex-1 min-h-0 
				bg-[#0a0015]
				border-2 border-t-[#39ff14] border-l-[#39ff14] border-b-[#bf00ff] border-r-[#bf00ff]
				flex flex-col
			"
		>
			<div className=" w-full
				grid grid-cols-10 bg-red-200
			">
				<div className="
					col-start-1 col-span-1
					bg-[#1a0033] border-b-2 border-[#ff003c] p-2  ">
					<BackButton label="Back" icon="⬅️" onClick={onBack} fitWidth />
				</div>
				<div className="
					col-start-2 col-span-10
					bg-[#1a0033] border-b-2 border-[#ff003c] px-2 py-2 space-y-1 text-sm 
					grid grid-cols-2
						">
					<div className="text-[#00f5ff]">
						<span className="font-bold text-[#ff2d78]">From:</span> {email.from}
					</div>
					<div className="text-[#39ff14]">
						<span className="font-bold text-[#ff2d78]">To:</span> {email.to}
					</div>
					<div className="text-[#ffe600]">
						<span className="font-bold text-[#ff2d78]">Subject:</span> {email.subject}
					</div>
					<div className="text-[#ff6f00]">
						<span className="font-bold text-[#ff2d78]">Date:</span> {email.date}
					</div>
				</div>
			</div>
			{email.htmlSrc ? (
				<iframe
					src={email.htmlSrc}
					title={email.subject}
					sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox"
					className="flex-1 min-h-0 w-full border-0"
				/>
			) : (
				<div className="text-sm p-3 space-y-2 overflow-y-auto text-[#e0d0ff]">
					{email.body?.map((line, i) => (
						<p key={i}>{line}</p>
					))}
				</div>
			)}
		</div>
	)
}
